document.documentElement.classList.remove('no-js');

class MenuDrawer extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-menu-toggle]');
    this.panel = this.querySelector('[data-menu-panel]');
    if (!this.button || !this.panel) return;
    this.button.addEventListener('click', () => this.toggle());
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.button.getAttribute('aria-expanded') === 'true') this.toggle(false);
    });
  }
  toggle(force) {
    const open = force ?? this.button.getAttribute('aria-expanded') !== 'true';
    this.button.setAttribute('aria-expanded', String(open));
    this.panel.hidden = !open;
    document.body.classList.toggle('menu-open', open);
    if (open) this.panel.querySelector('a')?.focus();
  }
}
customElements.define('menu-drawer', MenuDrawer);

class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = this.querySelector(`#${CSS.escape(button.dataset.target)}`);
        if (!target) return;
        this.querySelectorAll('[data-gallery-item]').forEach((item) => item.hidden = item !== target);
        this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.setAttribute('aria-current', String(thumb === button)));
      });
    });
  }
}
customElements.define('product-gallery', ProductGallery);

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const form = select.closest('form');
  const button = form?.querySelector('[data-add-to-cart]');
  const price = form?.closest('[data-product-root]')?.querySelector('[data-product-price]');
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
  }
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});
